
import { createBrowserRouter } from "react-router-dom";
import AppShell from "../components/app_shell";

export const topLevelRouter = createBrowserRouter([
    {
        element: <AppShell />,
        children: [
            {
                path: "/",
                lazy: {
                    Component: async () => {
                        return (await import("@/pages/container_list/container_list")).Protected;
                    },
                    ErrorBoundary: async () => {
                        return (await import("shared-lib")).ErrorRenderer;
                    }
                }
            },
            {
                path: "/containers/:id",
                lazy: {
                    Component: async () => {
                        return (await import("@/pages/container_detail/container_detail")).default;
                    },
                    ErrorBoundary: async () => {
                        return (await import("shared-lib")).ErrorRenderer;
                    }
                }
            },
            {
                // Customer-portal Bestellung deeplink — entry point for
                // the one-time-token confirmation flow. The token is
                // exchanged in `auth_page_wrapper.tsx`; after that the
                // app navigates here.
                path: "/bestellung/:id",
                lazy: {
                    Component: async () => {
                        return (await import("@/pages/bestellung/bestellung_detail")).default;
                    },
                    ErrorBoundary: async () => {
                        return (await import("shared-lib")).ErrorRenderer;
                    }
                }
            },
            {
                path: "no-access",
                lazy: {
                    Component: async () => {
                        return (await import("@/pages/no_access/no_access")).default;
                    },
                    ErrorBoundary: async () => {
                        return (await import("shared-lib")).ErrorRenderer;
                    }
                }
            }
        ]
    }
]);
